import classNames from 'classnames';
import { IconRecruitment } from '@medifind/icons';
import { Button } from '@medifind/shared-basic-components';
import { trialStatusInitialState, updateTrialStatusFilterOption, useClinicalTrialStepper } from '@medifind/zustand';
import RecruitingFooter from './RecruitingFooter';
import Step from './Step';
import styles from './StepShared.module.scss';

const RecruitingStep = ({ stepKey, handleStepSubmit, showOptional, trialCount, loading }) => {
  const steps = useClinicalTrialStepper((state) => state.steps);
  const recruitingStep = steps.find(({ key }) => key === stepKey);
  const { data, skip } = recruitingStep || {};

  const handleStepSubmitIntercept = (selection) => {
    if (selection) {
      const { display, value } = selection;
      if (value === 'Y') {
        const recruitingOptions = trialStatusInitialState.options.filter(({ value }) =>
          ['Recruiting', 'Open', 'Enrolling by invitation'].includes(value),
        );
        updateTrialStatusFilterOption(recruitingOptions);
      } else {
        updateTrialStatusFilterOption([]);
      }
      handleStepSubmit({ data: { display, value } });
    }
  };

  return (
    <Step
      title="Recruitment"
      subTitle="Are you looking for trials that you can enroll in now?"
      icon={<IconRecruitment />}
      footer={<RecruitingFooter />}
      optionsColStyles={styles['recruiting-step']}
      showNext={skip || data?.value}
      showOptional={showOptional}
      trialCount={trialCount}
      showTrialCount
      loading={loading}
    >
      <div className={styles['btn-row']}>
        <Button
          className={classNames(styles['btn'], { [styles['selected']]: data?.value === 'Y' })}
          onClick={() => handleStepSubmitIntercept({ display: 'Yes', value: 'Y' })}
          type="normal"
          label="Yes"
        />
        <Button
          className={classNames(styles['btn'], { [styles['selected']]: data?.value === 'N' })}
          onClick={() => handleStepSubmitIntercept({ display: 'No', value: 'N' })}
          type="normal"
          label="No"
        />
      </div>
    </Step>
  );
};

export default RecruitingStep;
